import { ICategory } from "types/marketpleace/category.interface";
import { IAttribute } from "types/marketpleace/attribute.interface";
import { IDelivery } from "types/marketpleace/delivery.interface";
import { PRODUCT_TYPES } from "types/marketpleace/product.interface";
import { demoDeliveryPhoto } from "./demoImages";

export const mockCategories: ICategory[] = [
  {
    CategoryId: "00000000-0000-0000-0000-000000000801",
    Name: "Odzież",
    Description: "Koszulki, spodenki i akcesoria treningowe",
  },
  {
    CategoryId: "00000000-0000-0000-0000-000000000802",
    Name: "Sprzęt",
    Description: "Piłki, bramki i sprzęt treningowy",
  },
  {
    CategoryId: "00000000-0000-0000-0000-000000000803",
    Name: "Cyfrowe",
    Description: "Materiały wideo i szkolenia online",
  },
];

export const mockAttributes: IAttribute[] = [
  {
    AttributeId: "00000000-0000-0000-0000-000000000901",
    Name: "Rozmiar",
    Values: [
      { ValueId: "00000000-0000-0000-0000-000000000911", Name: "S" },
      { ValueId: "00000000-0000-0000-0000-000000000912", Name: "M" },
      { ValueId: "00000000-0000-0000-0000-000000000913", Name: "L" },
    ],
  },
  {
    AttributeId: "00000000-0000-0000-0000-000000000902",
    Name: "Kolor",
    Values: [
      { ValueId: "00000000-0000-0000-0000-000000000921", Name: "Biały" },
      { ValueId: "00000000-0000-0000-0000-000000000922", Name: "Czarny" },
      { ValueId: "00000000-0000-0000-0000-000000000923", Name: "Niebieski" },
    ],
  },
  {
    AttributeId: "00000000-0000-0000-0000-000000000903",
    Name: "Materiał",
    Values: [
      { ValueId: "00000000-0000-0000-0000-000000000931", Name: "Poliester" },
      { ValueId: "00000000-0000-0000-0000-000000000932", Name: "Bawełna" },
    ],
  },
];

export const mockDeliveries: IDelivery[] = [
  {
    DeliveryId: "00000000-0000-0000-0000-000000000702",
    Name: "Odbiór osobisty",
    Description: "Odbiór w siedzibie akademii",
    Deadline: "0",
    Tax: 0,
    Netto: 0,
    Gross: 0,
    PhotoFilePath: demoDeliveryPhoto("00000000-0000-0000-0000-000000000702"),
    ConditionForFree: 0,
    AvailableFor: PRODUCT_TYPES["Fizyczny"],
  },
  {
    DeliveryId: "00000000-0000-0000-0000-000000000701",
    Name: "Digital",
    Description: "Dostawa cyfrowa / produkt elektroniczny",
    Deadline: "0",
    Tax: 23,
    Netto: 0,
    Gross: 0,
    PhotoFilePath: demoDeliveryPhoto("00000000-0000-0000-0000-000000000701"),
    ConditionForFree: 0,
    AvailableFor: PRODUCT_TYPES["Elektroniczny"],
  },
  {
    DeliveryId: "00000000-0000-0000-0000-000000000703",
    Name: "Paczkomat InPost",
    Description: "Dostawa do paczkomatu",
    Deadline: "48",
    Tax: 23,
    Netto: 9.76,
    Gross: 12,
    PhotoFilePath: demoDeliveryPhoto("00000000-0000-0000-0000-000000000703"),
    ConditionForFree: 150,
    AvailableFor: PRODUCT_TYPES["Fizyczny"],
  },
];

export const filterCategories = (search: string) =>
  mockCategories.filter(
    (category) =>
      category.Name.toLowerCase().includes(search) ||
      category.Description.toLowerCase().includes(search)
  );
